function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M2.34314575,2.25 L3.05025253,2.95710678 C1.78350169,4.22385763 1,5.97385763 1,7.90685425 C1,9.83985087 1.78350169,11.5898509 3.05025253,12.8566017 L2.34314575,13.5637085 C0.8954305,12.1159932 0,10.1159932 0,7.90685425 C0,5.69771525 0.8954305,3.69771525 2.34314575,2.25 Z M13.6568542,2.25 C15.1045695,3.69771525 16,5.69771525 16,7.90685425 C16,10.1159932 15.1045695,12.1159932 13.6568542,13.5637085 L12.9497475,12.8566017 C14.2164983,11.5898509 15,9.83985087 15,7.90685425 C15,5.97385763 14.2164983,4.22385763 12.9497475,2.95710678 L13.6568542,2.25 Z M7.5,9 L6,9 L6,8 L7.5,8 L7.5,6 L8.5,6 L8.5,9 L7.5,9 Z M8,13 C5.23857625,13 3,10.7614237 3,8 C3,5.23857625 5.23857625,3 8,3 C10.7614237,3 13,5.23857625 13,8 C13,10.7614237 10.7614237,13 8,13 Z M8,12 C10.209139,12 12,10.209139 12,8 C12,5.790861 10.209139,4 8,4 C5.790861,4 4,5.790861 4,8 C4,10.209139 5.790861,12 8,12 Z"
});

var SvgLegacy = function SvgLegacy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLegacy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Legacy.2c5812f1.svg";
export { ForwardRef as ReactComponent };